import { ReactNode } from "react";
import { Link } from "react-router";
import { BreadcrumbItemSeparator } from "./BreadcrumbItemSeparator";

/** The `BreadcrumbItem` component properties. */
export interface BreadcrumbItemProps {

  /** The breadcrumb item title. */
  readonly title: string;

  /** The breadcrumb item path. */
  readonly path?: string;
}

/** A breadcrumb item. */
export const BreadcrumbItem = (props: BreadcrumbItemProps): ReactNode => {
  const { title, path } = props;

  if (!path) return <span className="item">{title}</span>;

  return (
    <>
      <Link className="item" to={path}>
        {title}
      </Link>
      <BreadcrumbItemSeparator />
    </>
  );
};
